import React from "react";
import { Col, Row } from "reactstrap";
import NumberFormatField from "src/components/Form/NumberFormatFieldV2/NumberFormatFieldV2";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import * as S from "src/constants/StringConstants";

const ApplicantInformationForm = () => {
  return (
    <div>
      <Row>
        <Row>
          <Col sm="12" className="app-form-header">
            <h4 className="form-title">{S.APP_PRODUCT_APPLICANT_INFORMATION_TITLE}</h4>
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <NumberFormatField
              name="income"
              label={S.APP_PRODUCT_FIELD_INCOME}
              prefix="$"
              thousandSeparator={true}
              decimalScale={2}
            />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <TextField name="occupation" label={S.APP_PRODUCT_FIELD_OCCUPATION} />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <TextField name="occupationClass" label={S.APP_PRODUCT_FIELD_OCCUPATION_CLASS} />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <SimpleDatePickerField label={S.APP_PRODUCT_FIELD_APP_SIGNED_DATE} name="signedDate" isFormMode showClear />
          </Col>
        </Row>

        <Row style={{ marginTop: "35px" }}>
          <Col sm="12">
            <SimpleDatePickerField
              label={S.APP_PRODUCT_FIELD_APP_SUBMITTED_DATE}
              name="entryDate"
              isFormMode
              showClear
            />
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default ApplicantInformationForm;
